<nz-form-item>
  <nz-form-label *ngIf="!noLabelText" [nzRequired]="isRequired">{{labelText}}</nz-form-label>
  <nz-form-control
    [nzValidateStatus]="type"
    [nzErrorTip]="type === 'error' ? this.errorMessage : null"
    [nzWarningTip]="type === 'warning' ? this.errorMessage : null"
    [nzValidatingTip]="type === 'validating' ? this.errorMessage : null"
    [nzSuccessTip]="type === 'success' ? this.errorMessage : null">
    <ng-content></ng-content>
  </nz-form-control>
</nz-form-item>
